import React, {useContext, useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Info, X, CreditCard  } from 'lucide-react'
import payboxQR from "../Image/payboxQr.png"
import bitQR from "../Image/bitQr.jpg"
import bitLogo from "../Image/bit.png"
import payboxLogo from "../Image/paybox.png"
import paypalLogo from "../Image/paypal.png"
import LanguageSelector from "./language/LanguageSelector"
import {FamilyContext} from "../Context/FamilyHeadContext";

const DonationPage = () => {
    const { t } = useTranslation()
    const [showQR, setShowQR] = useState('')
    const { currentAnnouncement } = useContext(FamilyContext)
    const [showBankDetails, setShowBankDetails] = useState(false)

    useEffect(() => {
        document.body.style.overflow = 'hidden'
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [])

    const handleBitPayment = () => {
        if (window.innerWidth < 640) {
            window.open('https://www.bitpay.co.il/app/me/76B01423-1E90-0D85-6FDC-7BDBCA5939E3898B', '_blank')
        } else {
            setShowQR(bitQR)
        }
    }

    const handlePayboxPayment = () => {
        if (window.innerWidth < 640) {
            window.open('https://payboxapp.page.link/NR4HRCP5WX4YKUTF9', '_blank')
        } else {
            setShowQR(payboxQR)
        }
    }

    const handlePayPalPayment = () => {
        window.open('https://www.paypal.me/HarelKohen', '_blank')
    }

    const paymentOptions = [
        {
            name: t('payPopup.paymentMethods.bit'),
            handler: handleBitPayment,
            bgColor: 'bg-[#00353b]',
            logo: bitLogo,
            hoverColor: 'hover:bg-[#0c4c54]'
        },
        {
            name: t('payPopup.paymentMethods.paybox'),
            handler: handlePayboxPayment,
            bgColor: 'bg-[#4ca4dc]',
            logo: payboxLogo,
            hoverColor: 'hover:bg-[#69b2e3]'
        },
        {
            name: t('payPopup.paymentMethods.paypal'),
            handler: handlePayPalPayment,
            bgColor: 'bg-[#001f5c]',
            logo: paypalLogo,
            hoverColor: 'hover:bg-[#0e3175]'
        },
        {
            name: t('payPopup.paymentMethods.bankTransfer'),
            handler: () => setShowBankDetails(true),
            bgColor: 'bg-[#6b4e2b]',
            isIcon: true, // נוסיף שדה חדש לזיהוי אייקון
            icon: <CreditCard   className="w-10 h-10 sm:w-12 sm:h-12" />,
            hoverColor: 'hover:bg-[#8b663a]'
        }
    ]

    return (
        <div className="fixed inset-0 bg-gray-50 overflow-y-auto z-[9999]">
            <div className="min-h-screen p-4 flex flex-col items-center justify-center">
                {/* Main Card */}
                <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg">
                    {/* Progress Section */}
                    <div className="bg-gradient-to-r from-[#937c5d]/5 to-[#c9a66c]/5 p-8 rounded-t-2xl border-b border-[#937c5d]/10">
                        <div className="flex flex-col items-center gap-6">
                            {/* Language Selector */}
                            <div className="mt-1">
                                <LanguageSelector/>
                            </div>
                            {/* Subtitle */}
                            <p className="text-[#4a3f30] text-lg font-heebo text-center">
                                {t('donation.subtitle')}
                            </p>

                            {/* Amount Counter */}
                            <div className="flex flex-col items-center">
                                {t('donation.progress')}
                                <div
                                    className="text-6xl md:text-7xl font-bold text-[#937c5d] font-heebo tracking-tight">
                                    ₪{currentAnnouncement}
                                </div>
                                <div className="text-lg text-[#4a3f30]/70 mt-2 font-heebo">
                                    {t('donation.outOf')} ₪35,000
                                </div>
                            </div>

                            {/* Progress Bar */}
                            <div className="w-full h-4 bg-[#937c5d]/10 rounded-full overflow-hidden">
                                <div
                                    className="h-full bg-gradient-to-r from-[#937c5d] to-[#c9a66c] rounded-full transition-all duration-500"
                                    style={{
                                        width: `${Math.min((Number(currentAnnouncement) / 35000) * 100, 100)}%`
                                    }}
                                />
                            </div>

                            {/* Support Text */}
                            <div className="space-y-4">
                                {/* חלק ראשון - הודעת התמיכה הראשית */}
                                <p className="text-[#4a3f30] text-base font-heebo text-center">
                                    {t('donation.supportText')}
                                </p>

                                {/* חלק שני - הערה חשובה */}
                                <p className="text-[#937c5d] text-sm font-heebo text-center font-medium bg-[#937c5d]/5 py-2 px-4 rounded-lg flex items-center justify-center">
                                    <Info className="mr-4" size={18} color="#93775d" />
                                    {t('donation.note')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Payment Options */}
                    <div className="p-6 md:p-8">
                        <h2 className="text-lg font-medium text-[#4a3f30] text-center mb-6">
                            {t('donation.choosePayment')}
                        </h2>

                        {/* Unified Payment Options Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                            {paymentOptions.map((option, index) => (
                                <button
                                    key={index}
                                    onClick={option.handler}
                                    className={`${option.bgColor} ${option.hoverColor}
            transition-all duration-200 rounded-xl p-4 md:p-6
            flex flex-row sm:flex-col items-center justify-center gap-3
            text-white text-lg font-heebo w-full
            hover:shadow-lg hover:-translate-y-0.5`}
                                >
                                    {option.isIcon ? option.icon : (
                                        <img
                                            crossOrigin="use-credentials"
                                            src={option.logo}
                                            alt={option.name}
                                            className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                                        />
                                    )}
                                    <span className="text-base sm:text-lg">{option.name}</span>
                                </button>
                            ))}
                        </div>

                        {showBankDetails && (
                            <div
                                className="fixed inset-0 bg-black/80 flex items-center justify-center z-[60]"
                                onClick={() => setShowBankDetails(false)}
                            >
                                <div
                                    className="relative bg-white rounded-xl p-8 max-w-md w-full mx-4"
                                    onClick={e => e.stopPropagation()}
                                >
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setShowBankDetails(false)
                                        }}
                                        className="absolute -top-2 -right-2 p-2 bg-teal-800 rounded-full hover:bg-teal-600"
                                    >
                                        <X className="w-5 h-5 text-white" />
                                    </button>

                                    <h2 className="text-2xl font-heebo font-bold text-[#937c5d] mb-6 text-center">
                                        {t('payPopup.bankTransferDetails')}
                                    </h2>

                                    <div className="space-y-4">
                                        <div className="bg-[#937c5d]/5 p-6 rounded-xl mx-auto max-w-sm">
                                            <div className="space-y-3">
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#4a3f30]">  {t('payPopup.bankDetails.bank')}</span>
                                                    <span className="font-medium text-[#937c5d]">  {t('payPopup.bankDetails.bankName')}</span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#4a3f30]">  {t('payPopup.bankDetails.branch')}</span>
                                                    <span className="font-medium text-[#937c5d]">76</span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#4a3f30]">  {t('payPopup.bankDetails.account')}</span>
                                                    <span className="font-medium text-[#937c5d]">93231</span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#4a3f30]">  {t('payPopup.bankDetails.name')}</span>
                                                    <span className="font-medium text-[#937c5d]">  {t('payPopup.bankDetails.accountName')}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Disclaimer */}
                        <p className="text-gray-500 text-sm text-center mt-8 font-heebo">
                            {t('donation.disclaimer')}
                        </p>
                    </div>
                </div>
            </div>

            {/* QR Code Modal */}
            {showQR && (
                <div
                    className="fixed inset-0 bg-black/80 flex items-center justify-center z-[60]"
                    onClick={() => setShowQR('')}
                >
                    <div className="relative bg-white rounded-xl p-4 max-w-md">
                        <button
                            onClick={(e) => {
                                e.stopPropagation()
                                setShowQR('')
                            }}
                            className="absolute -top-2 -right-2 p-2 bg-teal-800 rounded-full hover:bg-teal-600"
                        >
                            <X className="w-5 h-5 text-white" />
                        </button>
                        <h2 className="text-2xl font-heebo font-bold text-[#937c5d] mb-6">
                            {t('payPopup.scanQRCode')}
                        </h2>
                        <img
                            crossOrigin="use-credentials"
                            src={showQR}
                            alt="QR Code"
                            className="w-96 h-96 object-contain"
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default DonationPage